/* eslint-disable max-len */
import 'react';

const ShareTooltipsSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_32093_23527" style={{'maskType': 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
            <rect width="18" height="18" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_32093_23527)">
            <path d="M9.1875 15.9375C12.9154 15.9375 15.9375 12.9154 15.9375 9.1875C15.9375 5.45958 12.9154 2.4375 9.1875 2.4375C5.45958 2.4375 2.4375 5.45958 2.4375 9.1875C2.4375 12.9154 5.45958 15.9375 9.1875 15.9375Z" stroke="#39404D" strokeWidth="1.125" />
            <path d="M9.9375 11.9829C9.9375 11.5687 9.60171 11.2329 9.1875 11.2329C8.77329 11.2329 8.4375 11.5687 8.4375 11.9829C8.4375 12.3971 8.77329 12.7329 9.1875 12.7329C9.60171 12.7329 9.9375 12.3971 9.9375 11.9829Z" fill="#39404D" />
            <path d="M7.34668 7.59211C7.34668 6.73302 8.13998 6.11938 9.15669 6.11938C10.1734 6.11938 10.9239 6.69211 10.9239 7.5512C10.9239 8.57393 9.18759 8.77848 9.15668 9.8012C9.15668 9.8012 9.15668 10.0739 9.15668 10.2103" stroke="#39404D" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>


);
export default ShareTooltipsSvg;
